var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Footer Summary")]),_c('Explain'),_c('Base'),_c('CustomCell'),_c('CellStyle'),_c('CellSpan'),_c('OnFooterRow'),_c('OnFooterCell'),_c('FooterFixed'),_c('FooterColumnFixed'),_c('VirtualScroll')],1)}
var staticRenderFns = []

export { render, staticRenderFns }